import * as React from "react";
import { cn } from "../../utils/cn";

export interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
  icon?: React.ReactNode;
  iconClass?: string;
  /** extra classes for the outer wrapper */
  wrapperClass?: string;
  /** kept for backward-compat (alias of wrapperClass) */
  wraperClass?: string;
  /** extra classes for the immediate relative container */
  divClass?: string;
}

const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (
    {
      icon,
      iconClass,
      wrapperClass,
      wraperClass, // alias
      className,
      divClass,
      error,
      rows = 3,
      ...props
    },
    ref
  ) => {
    const hasIcon = Boolean(icon);

    return (
      <div className={cn("flex flex-col gap-1", wrapperClass ?? wraperClass)}>
        <div className={cn("relative w-full", divClass)}>
          {icon && (
            <span className={cn("pointer-events-none absolute left-3 top-3 text-gray-500", iconClass)}>{icon}</span>
          )}

          <textarea
            className={cn(
              "border border-border-gray text-gray-900 rounded-md w-full min-h-[128px] py-[9px] px-[13px] z-0 text-base bg-input-bg",
              // kill focus styles
              "outline-none focus:outline-none focus:ring-0 focus:ring-offset-0 focus:shadow-none focus:border-border-gray",
              "focus-visible:outline-none focus-visible:ring-0",
              error ? "border-red-500" : "border-border-gray",
              className
            )}
            ref={ref}
            {...props}
          />
        </div>

        {error && (
          <p id="textarea-error" className="text-sm text-red-500">
            {error}
          </p>
        )}
      </div>
    );
  }
);

TextArea.displayName = "TextArea";

export { TextArea };
